// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--btDrp {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  color: currentColor;\n}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Nav/index.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".icon {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  color: currentColor;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--btDrp"
};
export default ___CSS_LOADER_EXPORT___;
